//  << CODE BELOW IS FULL FILE — PURPOSE 2 / 3 SEPARATED >>

import React, { useEffect, useState, useRef } from "react";
import { Icon } from "@iconify/react";
import api from "../../../utils/axios";
import Swal from "sweetalert2";
import { useParams, useLocation } from "react-router-dom";
import DatePicker from "../DatePicker";
import moment from "moment";
import "moment/locale/th";

import CustomerModal from "../../components/Modal/Quote/Admin/CustomerModal";
import ServiceLocationModal from "../../components/Modal/Quote/Admin/Service2ndModal";
import LocationModal from "../../components/Modal/LocationModal";
import FileModalLocation from "../../components/Modal/FileModalLocation";
import { getReport } from "../../../utils/ReportUtils";
import { getData } from "../../../utils/SamuiUtils";

/* format ตัวเลขเหมือนตารางรายการสินค้า/บริการ */
function formatWithCommas(numStr) {
  if (numStr === null || numStr === undefined || numStr === "") return "";
  const parts = numStr.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
}

const SubIntegerInput = ({ value, onValueChange, disabled }) => {
  const [localValue, setLocalValue] = useState("");
  useEffect(() => {
    if (value === null || value === undefined || value === "") setLocalValue("");
    else setLocalValue(String(value));
  }, [value]);
  const handleFocus = (e) => e.target.select();
  const handleChange = (e) => {
    let raw = e.target.value.replace(/\D/g, "");
    if (raw === "0") raw = "";
    setLocalValue(raw);
    onValueChange(raw ? parseInt(raw) : 0);
  };
  const handleBlur = () => {
    if (!localValue) {
      setLocalValue("1");
      onValueChange(1);
    }
  };
  return (
    <input
      type="text"
      value={localValue}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      className="w-full h-[42px] border border-gray-300 rounded-md px-3 py-1 text-right text-[14px] focus:ring-1 focus:ring-[#E13F57] focus:border-[#E13F57]"
      inputMode="numeric"
    />
  );
};

const SubNumberInput = ({ value, onValueChange, disabled }) => {
  const [localValue, setLocalValue] = useState("");
  const inputRef = useRef(null);
  useEffect(() => {
    if (document.activeElement !== inputRef.current) {
      if (value === null || value === undefined || value === "") setLocalValue("");
      else setLocalValue(formatWithCommas(parseFloat(value).toFixed(2)));
    }
  }, [value]);
  const handleFocus = (e) => e.target.select();
  const handleChange = (e) => {
    let raw = e.target.value.replace(/,/g, "");
    if (!/^\d*\.?\d*$/.test(raw)) return;
    const parts = raw.split(".");
    if (parts[1]?.length > 2) return;
    let displayVal = raw;
    if (parts[0].length > 3) displayVal = formatWithCommas(raw);
    setLocalValue(displayVal);
    onValueChange(parseFloat(raw) || 0);
  };
  const handleBlur = () => {
    const numericValue = parseFloat(localValue.replace(/,/g, "")) || 0;
    setLocalValue(formatWithCommas(numericValue.toFixed(2)));
    onValueChange(numericValue);
  };
  return (
    <input
      ref={inputRef}
      type="text"
      value={localValue}
      onFocus={handleFocus}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      className="w-full h-[42px] border border-gray-300 rounded-md px-3 py-1 text-right text-[14px] focus:ring-1 focus:ring-[#E13F57] focus:border-[#E13F57] transition"
      inputMode="decimal"
    />
  );
};

export default function QuoteHeader({
  header,
  setHeader,
  onSave,
  selectedFiles,
  setSelectedFiles,
  contractInfo,
  subLocations = [],
  setSubLocations,
  itemsCount = 0,
  disabled = false,
}) {
  const [employees, setEmployees] = useState([]);
  const [loadingEmp, setLoadingEmp] = useState(false);

  const [customerModalOpen, setCustomerModalOpen] = useState(false);
  const [serviceModalOpen, setServiceModalOpen] = useState(false);
  const [serviceModalPurpose, setServiceModalPurpose] = useState(null);

  const [locationModalOpen, setLocationModalOpen] = useState(false);
  const [showFileModal, setShowFileModal] = useState(false);

  const params = useParams();
  const location = useLocation();
  const query = new URLSearchParams(location.search);

  const isCreate = location.pathname.includes("/quote/create");
  const isEdit = location.pathname.includes("/quote/edit");
  const mode = query.get("mode") || "";
  const docCodeId = 6;

  const isAdmin = location.pathname.includes("/admin") || mode === "approve";

  const AR_Id = query.get("AR_Id") || params.AR_Id || null;
  const Doc_Id = isEdit ? params.Doc_Id : null;

  const [serviceLocations, setServiceLocations] = useState([]);
  const [serviceTypes, setServiceTypes] = useState([]);

  useEffect(() => {
    const fetchServiceTypes = async () => {
      try {
        const res = await getData(
          "Tb_Set_ServiceAddrType",
          "ServiceAddr_Type_Status = 'Y'"
        );
        const rows = Array.isArray(res) ? res : res?.data || [];
        const mapped = rows
          .map((item) => ({
            id: item?.ServiceAddr_Type_Id ?? item?.id ?? item?.Id,
            name:
              item?.ServiceAddr_Type_Name ??
              item?.name ??
              item?.ServiceAddr_Type,
          }))
          .filter((item) => item.id && item.name);
        setServiceTypes(mapped);
      } catch (err) {
        console.error("โหลดประเภทสถานที่บริการไม่สำเร็จ:", err);
        setServiceTypes([]);
      }
    };
    fetchServiceTypes();
  }, []);

  const formatPhone = (val) => {
    if (!val) return "";
    const digits = val.replace(/\D/g, "").slice(0, 10);
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  };

  const formatTaxId = (tax) => {
    if (!tax) return "";
    let digits = tax.toString().replace(/\D/g, "").slice(0, 13);
    if (digits.length >= 13) {
      return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5, 10)}-${digits.slice(
        10,
        12
      )}-${digits[12]}`;
    }
    if (digits.length >= 11) {
      return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5, 10)}-${digits.slice(10)}`;
    }
    if (digits.length >= 6) {
      return `${digits[0]}-${digits.slice(1, 5)}-${digits.slice(5)}`;
    }
    if (digits.length >= 2) {
      return `${digits[0]}-${digits.slice(1)}`;
    }
    return digits;
  };

  const formatAddress = (loc) => {
    if (!loc) return "";
    return [
      loc.AddrNo ? `เลขที่ ${loc.AddrNo}` : "",
      loc.Building ? `อาคาร ${loc.Building}` : "",
      loc.Village ? `หมู่บ้าน ${loc.Village}` : "",
      loc.Moo ? `ม.${loc.Moo}` : "",
      loc.Soi ? `ซ.${loc.Soi}` : "",
      loc.Road ? `ถ.${loc.Road}` : "",
      loc.SubDistrictName ? `ต.${loc.SubDistrictName}` : "",
      loc.DistrictName ? `อ.${loc.DistrictName}` : "",
      loc.ProvinceName ? `จ.${loc.ProvinceName}` : "",
      loc.Zipcode || "",
    ]
      .filter(Boolean)
      .join(" ");
  };

  const renderStatus = (status) => {
    const base = "px-2 py-1 rounded-md text-[14px] font-medium";
    switch (status) {
      case 0:
        return <span className={`${base} bg-gray-100 text-gray-600`}>ร่าง</span>;
      case 1:
        return <span className={`${base} bg-yellow-100 text-yellow-700`}>รอเซ็น</span>;
      case 2:
        return <span className={`${base} bg-green-100 text-green-700`}>ใช้งาน</span>;
      case 5:
        return <span className={`${base} bg-red-100 text-red-600`}>ยกเลิก</span>;
      case 4:
        return <span className={`${base} bg-blue-100 text-blue-700`}>เซ็นแล้ว</span>;
      default:
        return <span className={`${base} bg-gray-200 text-gray-600`}>ไม่ทราบ</span>;
    }
  };



  useEffect(() => {
    if (!header.Comp_Id) return;

    const fetchEmployees = async () => {
      try {
        setLoadingEmp(true);
        const res = await api.get(`/get-employees/${header.Comp_Id}`);

        let employeeList = [];
        if (res.data?.status === "OK" && Array.isArray(res.data.result?.recordset)) {
          employeeList = res.data.result.recordset;
        } else if (Array.isArray(res.data.result)) {
          employeeList = res.data.result;
        }

        setEmployees(employeeList);

        const localEmpId = Number(localStorage.getItem("emp_id"));
        const localEmpName = localStorage.getItem("name");

        if (!header.Sale_Emp_Id && localEmpId) {
          const found = employeeList.find((e) => e.Emp_Id === localEmpId);
          setHeader((prev) => ({
            ...prev,
            Sale_Emp_Id: localEmpId,
            Sale_Emp_Name: found ? found.Emp_Name : localEmpName || "",
          }));
        }
      } catch {
        Swal.fire("ผิดพลาด", "ไม่สามารถโหลดรายชื่อพนักงานขายได้", "error");
      } finally {
        setLoadingEmp(false);
      }
    };

    fetchEmployees();
  }, [header.Comp_Id, setHeader]);

  useEffect(() => {
    const fetchQuoteFiles = async () => {
      if (!showFileModal || !Doc_Id) return;
      try {
        const res = await api.get(`/get-quote-file/${Doc_Id}`);

        if (res.data.status === "OK") {
          const dbFiles = res.data.result.map((f) => ({
            File_Id: f.F_Id,
            File_Name: f.File_Name,
            File_Url: f.File_Url,
            Upload_By: f.Upload_By,
            Upload_Date: f.Upload_Date,
            size: f.File_Size || 1024,
            type: f.File_Type || "application/octet-stream",
            isNew: false,
            rawFile: null,
          }));

          setSelectedFiles((prev) => {
            const pending = prev.filter((p) => p.isNew);
            return [...dbFiles, ...pending];
          });
        }
      } catch {
        Swal.fire("ผิดพลาด", "ไม่สามารถโหลดไฟล์แนบได้", "error");
      }
    };

    fetchQuoteFiles();
  }, [showFileModal, Doc_Id, setSelectedFiles]);

  useEffect(() => {
    if (!header.AR_Id) return;

    api.get(`/get-tb-set-ar1/${header.AR_Id}`).then((res) => {
      if (res.data.status === "OK" && res.data.result?.recordset?.length > 0) {
        const c = res.data.result.recordset[0];
        const fullName = `${c.AR_Name || ""} ${c.AR_LastName || ""}`.trim();
        

        setHeader((prev) => ({
          ...prev,
          AR_Name: fullName,
          Comp_Id: c.Comp_Id || prev.Comp_Id,
          DisplayName:
            prev.DisplayName?.trim() && prev.DisplayName !== ""
              ? prev.DisplayName
              : c.DisplayName?.trim() || fullName,
          AR_TaxNo: formatTaxId(prev.AR_TaxNo || c.AR_TaxNo || ""),
          AR_Tel: formatPhone(prev.AR_Tel || c.AR_Tel || ""),
          AR_ContactName: c.AR_ContactName || prev.AR_ContactName || "",
          Contract_ContactName: prev.Contract_ContactName || prev.AR_ContactName || "",
          Contract_ContactTel: prev.Contract_ContactTel || "",

        }));
      }
    });
  }, [header.AR_Id, setHeader]);

  useEffect(() => {
    if (!header.AR_Id) return;

    api.get(`/get-tb-set-service-addr/${header.AR_Id}`)
      .then((res) => {
        if (res.data.status !== "OK") return;

        const list = res.data.result?.recordset || [];
        setServiceLocations(list);

        const isServiceAddr = (x) =>
          (x.ServicePurpose_Name || "").trim() === "ที่อยู่บริการ" ||
          Number(x.ServicePurpose) === 6;
        const isContractAddr = (x) =>
          (x.ServicePurpose_Name || "").trim() === "ที่อยู่ทำสัญญา" ||
          Number(x.ServicePurpose) === 7;

        const purpose2List = list.filter(isServiceAddr);
        const purpose3List = list.filter(isContractAddr);

        const location2 =
          purpose2List.find(x => x.IsDefault === 1) || purpose2List[0] || null;
        const location3 =
          purpose3List.find(x => x.IsDefault === 1) ||
          purpose3List[0] ||
          purpose2List[0] ||
          null;

        if (location2 && !header.ServiceAddr_Id) {
          setHeader(prev => ({
            ...prev,
            ServiceAddr_Id: location2.ServiceAddr_Id,
            ServiceAddr_Name: location2.ServiceAddr_Name,
            ServiceAddr_FullText: location2.FullAddress,
            Service_ContactName: location2.AR_ContactName || "",
            Service_ContactTel: formatPhone(location2.AR_Tel || ""),
          }));
        }

        if (location3) {
          setHeader(prev => ({
            ...prev,
            Contract_ServiceAddr_Id: location3.ServiceAddr_Id,
            Contract_ServiceAddr_Name: location3.ServiceAddr_Name,
            Contract_ServiceAddr_FullText: location3.FullAddress,
            Contract_ContactName: location3.AR_ContactName || "",
            Contract_ContactTel: formatPhone(location3.AR_Tel || "")
          }));
        }


      })
      .catch((err) => console.error("โหลดสถานที่บริการล้มเหลว:", err));
  }, [header.AR_Id]);

  const isSameLocation =
    header.ServiceAddr_Id != null &&
    header.Contract_ServiceAddr_Id != null &&
    header.ServiceAddr_Id === header.Contract_ServiceAddr_Id;
  const sameLocationAddr = isSameLocation
    ? (header.Contract_ServiceAddr_FullText || header.ServiceAddr_FullText || "")
    : null;

  // ทำให้ที่อยู่แสดงบรรทัดเดียว (ตัด newline ที่อาจมาจากข้อมูลหรือ backend)
  const normalizeAddressDisplay = (str) =>
    (str || "").replace(/\r?\n/g, " ").replace(/\s+/g, " ").trim();

  return (
    <div className="bg-white p-6 rounded-xl shadow space-y-4 text-[14px]">
      <div className="flex justify-between items-center">
        <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
          {isEdit
            ? `แก้ไขใบเสนอราคา (QT) ${header.Doc_Ref || header.Doc_No || ""}`
            : `สร้างใบเสนอราคา (QT) ${header.Doc_Ref || header.Doc_No || ""}`}
          <span
            className={`inline-flex items-center justify-center gap-[6px] px-2 py-[2px] rounded-[16px] text-white text-[14px] font-medium ${
              header.Doc_Status === 1 ? "bg-[#F17F25]" : "bg-green-600"
            }`}
          >
            <span className="w-2 h-2 rounded-full bg-white"></span>
            {header.Doc_Status === 1 ? "รออนุมัติ" : "อนุมัติแล้ว"}
          </span>

          {contractInfo?.hasContract && (
            <div className="flex items-center gap-2 ml-4">

              {/* 🔵 เลขที่สัญญา */}
              <span className="px-2 py-1 text-[14px] bg-blue-500 text-white rounded-md">
                มีสัญญาแล้ว: {contractInfo.contractDocNo}
              </span>

              {/* 🟢 สถานะสัญญา (ใช้ของจริง) */}
              {renderStatus(Number(contractInfo.contractStatus))}
            </div>
          )}

          
        </h2>

        <div className="flex items-center gap-2">
          <div className="relative inline-block">
            <button
              type="button"
              onClick={() => {
                if (!header.ServiceAddr_Id)
                  return Swal.fire(
                    "ไม่พบสถานที่บริการ",
                    "กรุณาเลือกสถานที่บริการก่อนแนบไฟล์",
                    "warning"
                  );
                setShowFileModal(true);
              }}
              className="flex items-center gap-2 bg-[#F17F25] hover:bg-[#d96a1f] text-white px-4 py-2 rounded-lg"
            >
              <Icon icon="mdi:paperclip" className="w-5 h-5" /> แนบไฟล์
            </button>

            {selectedFiles.length > 0 && (
              <span className="absolute -top-2 -right-2 bg-red-600 text-white text-xs font-bold px-[6px] py-[1px] rounded-full shadow-md">
                {selectedFiles.length}
              </span>
            )}
          </div>

          {!isCreate && header.Doc_Id && (
            <button
              type="button"
              onClick={() => getReport("qt", header.Doc_Id)}
              className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
            >
              <Icon icon="mdi:printer" className="w-5 h-5" /> พิมพ์
            </button>
          )}
        </div>
      </div>

      <div className="bg-white rounded-xl shadow-md p-5 border border-gray-200 text-[14px] leading-relaxed">
        <h2 className="text-[16px] font-semibold text-gray-700 mb-3">
          รายละเอียดใบเสนอราคา (QT)
        </h2>

        <div className="grid grid-cols-12 gap-4 mb-4">
          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">
              วันที่เอกสาร <span className="text-red-500">*</span>
            </label>
            <DatePicker
              name="Doc_Date"
              value={
                header.Doc_Date || ""
              }
              onChange={(date) =>
                setHeader((prev) => ({
                  ...prev,
                  Doc_Date: date || "",
                }))
              }
            />
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">
              พนักงานขาย <span className="text-red-500">*</span>
            </label>
            <select
              value={header.Sale_Emp_Id || ""}
              onChange={(e) => {
                const emp = employees.find((x) => x.Emp_Id === Number(e.target.value));
                setHeader((prev) => ({
                  ...prev,
                  Sale_Emp_Id: Number(e.target.value),
                  Sale_Emp_Name: emp ? emp.Emp_Name : "",
                }));
              }}
              className="w-full h-9 border rounded-md px-2"
            >
              <option value="">
                {loadingEmp ? "กำลังโหลด..." : "เลือกพนักงานขาย"}
              </option>
              {employees.map((emp) => (
                <option key={emp.Emp_Id} value={emp.Emp_Id}>
                  {emp.Emp_Name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 mb-4">
          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">
              ชื่อลูกค้า <span className="text-red-500">*</span>
            </label>
            <div className="flex items-center border rounded-md h-9 overflow-hidden">
              <input
                type="text"
                value={header.AR_Name || ""}
                readOnly
                className="flex-1 h-full px-2 bg-gray-100"
              />
              <button
                type="button"
                onClick={() => {
                  if (isAdmin) setCustomerModalOpen(true);
                  else
                    Swal.fire(
                      "ไม่สามารถเปลี่ยนลูกค้าได้",
                      "ลูกค้าเห็นข้อมูลของตนเองเท่านั้น",
                      "info"
                    );
                }}
                className={`p-2 bg-white border-l ${
                  !isAdmin ? "opacity-40 cursor-not-allowed" : "hover:bg-gray-100"
                }`}
              >
                <Icon icon="mdi:magnify" className="text-gray-500 w-5 h-5" />
              </button>
            </div>
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1 whitespace-nowrap">
              ชื่อผู้ติดต่อ (สถานที่บริการ)
            </label>
            <input
              type="text"
              value={
                header.Service_ContactName ||
                header.AR_ContactName ||
                ""
              }
              readOnly
              className="w-full h-9 border rounded-md px-2 bg-gray-100"
            />
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1 whitespace-nowrap">
              เบอร์โทรศัพท์ (สถานที่บริการ)
            </label>
            <input
              type="text"
              value={
                header.Service_ContactTel ||
                header.AR_Tel ||
                ""
              }
              readOnly
              className="w-full h-9 border rounded-md px-2 bg-gray-100"
            />
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">ชื่อที่ใช้ในสัญญา</label>
            <input
              type="text"
              value={header.DisplayName || ""}
              onChange={(e) =>
                setHeader((prev) => ({ ...prev, DisplayName: e.target.value }))
              }
              className="w-full h-9 border rounded-md px-2"
            />
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">
              ชื่อผู้ติดต่อ
            </label>
            <input
              type="text"
              value={header.Contract_ContactName || ""}
              readOnly
              className="w-full h-9 border rounded-md px-2 bg-gray-100"
            />
          </div>

          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1">
              เบอร์โทรศัพท์
            </label>
            <input
              type="text"
              value={header.Contract_ContactTel || ""}
              readOnly
              className="w-full h-9 border rounded-md px-2 bg-gray-100"
            />
          </div>
          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1 whitespace-nowrap">
              เลขประจำตัวผู้เสียภาษี
            </label>
            <input
              type="text"
              value={header.AR_TaxNo || ""}
              onChange={(e) =>
                setHeader((prev) => ({
                  ...prev,
                  AR_TaxNo: formatTaxId(e.target.value),
                }))
              }
              className="w-full h-9 border rounded-md px-2"
            />
          </div>

          <div className="col-span-12 md:col-span-8">
            <label className="block font-medium mb-1 whitespace-nowrap">
              ที่อยู่ที่ใช้ในสัญญา
            </label>
            <div className="flex items-center border rounded-md h-9 overflow-hidden bg-gray-100">
              <input
                type="text"
                value={normalizeAddressDisplay(
                  sameLocationAddr !== null
                    ? sameLocationAddr
                    : (header.Contract_ServiceAddr_FullText || "")
                )}
                readOnly
                disabled
                className="flex-1 h-full px-2 bg-gray-100 text-gray-700 border-0 outline-none"
              />
              <button
                type="button"
                onClick={() => {
                  if (!header.AR_Id)
                    return Swal.fire(
                      "ยังไม่มีลูกค้า",
                      "กรุณาเลือกลูกค้าก่อนเลือกสถานที่ (ใช้ในสัญญา)",
                      "warning"
                    );
                  setServiceModalPurpose("3");
                  setServiceModalOpen(true);
                }}
                className="p-2 bg-white border-l hover:bg-gray-100"
              >
                <Icon icon="mdi:map-marker" className="text-gray-500 w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 mb-6">
          <div className="col-span-12 md:col-span-4">
            <label className="block font-medium mb-1 whitespace-nowrap">
              ชื่อสถานที่บริการ
            </label>
            <input
              type="text"
              value={header.ServiceAddr_Name || ""}
              readOnly
              className="w-full h-9 border rounded-md px-2 bg-gray-100"
            />
          </div>

          <div className="col-span-12 md:col-span-8">
            <label className="block font-medium mb-1 whitespace-nowrap">
              ที่อยู่สถานที่บริการ
            </label>
            <div className="flex items-center border rounded-md h-9 overflow-hidden bg-gray-100">
              <input
                type="text"
                value={normalizeAddressDisplay(
                  sameLocationAddr !== null
                    ? sameLocationAddr
                    : (header.ServiceAddr_FullText || "")
                )}
                readOnly
                disabled
                className="flex-1 h-full px-2 bg-gray-100 text-gray-700 border-0 outline-none"
              />
              <button
                type="button"
                onClick={() => {
                  if (!header.AR_Id)
                    return Swal.fire(
                      "ยังไม่มีลูกค้า",
                      "กรุณาเลือกลูกค้าก่อนเลือกสถานที่บริการ",
                      "warning"
                    );
                  setServiceModalPurpose("2");
                  setServiceModalOpen(true);
                }}
                className="p-2 bg-white border-l hover:bg-gray-100"
              >
                <Icon icon="mdi:map-marker" className="text-gray-500 w-5 h-5" />
              </button>
            </div>
          </div>
        </div>

        {/* จุดย่อยสถานที่บริการ - UI เหมือนตารางรายการสินค้า/บริการ */}
        {setSubLocations && (
          <div className="bg-white rounded-xl shadow-md p-6 mt-6 border border-gray-300 text-[14px]">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-bold text-gray-700 text-lg">จุดย่อยสถานที่บริการ</h3>
              <button
                type="button"
                disabled={disabled}
                onClick={() => {
                  const locId = header.ServiceAddr_Id || header.Contract_ServiceAddr_Id;
                  if (!locId) {
                    Swal.fire({
                      icon: "warning",
                      title: "กรุณาเลือกสถานที่บริการ",
                      text: "กรุณาเลือกสถานที่บริการหรือสถานที่ทำสัญญาก่อนเพิ่มจุดย่อย",
                      confirmButtonColor: "#E13F57",
                    });
                    return;
                  }
                  if (!header.ServiceAddr_Id && header.Contract_ServiceAddr_Id) {
                    setHeader((prev) => ({
                      ...prev,
                      ServiceAddr_Id: prev.Contract_ServiceAddr_Id,
                      ServiceAddr_Name: prev.Contract_ServiceAddr_Name || prev.Contract_ServiceAddr_FullText,
                      ServiceAddr_FullText: prev.Contract_ServiceAddr_FullText,
                    }));
                  }
                  if (itemsCount > 1) {
                    Swal.fire({
                      icon: "warning",
                      title: "เมื่อมีจุดย่อย จะมีได้แค่บริการเดียว",
                      text: "กรุณาลดรายการบริการให้เหลือ 1 รายการก่อนเพิ่มจุดย่อย",
                      confirmButtonColor: "#E13F57",
                    });
                    return;
                  }
                  setSubLocations((prev) => [
                    ...prev,
                    {
                      Sub_Name: "",
                      Qty: 0,
                      Price_Unit: 0,
                      Discount: 0,
                      IsVat: false,
                      Sub_Img: null,
                      Sub_Img_Url: null,
                    },
                  ]);
                }}
                className="flex items-center gap-1 text-[#F17F25] text-sm font-semibold border-b-2 border-[#F17F25] pb-0.5 hover:text-[#c7641c] transition disabled:opacity-50 disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-400"
              >
                <Icon icon="mdi:plus-circle-outline" className="w-5 h-5" />
                เพิ่มจุดย่อย
              </button>
            </div>
            {subLocations.length > 0 && (
              <div className="overflow-x-auto rounded-lg border border-gray-300">
                <table className="table-fixed w-full border border-gray-300 text-[14px]">
                  <thead>
                    <tr>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[6%] py-2">ลำดับ</th>
                      <th className="bg-[#E13F57] text-white text-left border border-gray-300 w-[18%] py-2">ชื่อจุดย่อย</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[7%] py-2">จำนวน</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[13%] py-2">ราคาต่อหน่วย</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[10%] py-2">ส่วนลด</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[12%] py-2">รวม</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[10%] py-2">รูป</th>
                      <th className="bg-[#E13F57] text-white text-center border border-gray-300 w-[6%] py-2">ลบ</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subLocations.map((row, index) => {
                      const total = (row.Qty * row.Price_Unit - row.Discount);
                      let subImgSrc = row.Sub_Img_Url || null;
                      if (!subImgSrc && row.Sub_Img?.data) {
                        try {
                          subImgSrc = URL.createObjectURL(new Blob([new Uint8Array(row.Sub_Img.data)], { type: "image/*" }));
                        } catch (_) {}
                      }
                      if (!subImgSrc && typeof row.Sub_Img === "string") subImgSrc = row.Sub_Img;
                      return (
                        <tr key={index} className="odd:bg-white even:bg-gray-50 hover:bg-gray-100">
                          <td className="text-center border border-gray-300 py-2">{index + 1}</td>
                          <td className="border border-gray-300 px-2 py-2">
                            <input
                              type="text"
                              value={row.Sub_Name}
                              onChange={(e) =>
                                setSubLocations((prev) =>
                                  prev.map((r, i) => (i === index ? { ...r, Sub_Name: e.target.value } : r))
                                )
                              }
                              disabled={disabled}
                              className="w-full h-[42px] border border-gray-300 rounded-md px-3 py-1 text-[14px] focus:ring-1 focus:ring-[#E13F57] focus:border-[#E13F57]"
                              placeholder="ชื่อจุดย่อย"
                            />
                          </td>
                          <td className="border border-gray-300 px-1 py-2">
                            <SubIntegerInput
                              value={row.Qty ?? 0}
                              onValueChange={(v) =>
                                setSubLocations((prev) =>
                                  prev.map((r, i) => (i === index ? { ...r, Qty: v } : r))
                                )
                              }
                              disabled={disabled}
                            />
                          </td>
                          <td className="border border-gray-300 px-1 py-2">
                            <SubNumberInput
                              value={row.Price_Unit ?? 0}
                              onValueChange={(v) =>
                                setSubLocations((prev) =>
                                  prev.map((r, i) => (i === index ? { ...r, Price_Unit: v } : r))
                                )
                              }
                              disabled={disabled}
                            />
                          </td>
                          <td className="border border-gray-300 px-1 py-2">
                            <SubNumberInput
                              value={row.Discount ?? 0}
                              onValueChange={(v) =>
                                setSubLocations((prev) =>
                                  prev.map((r, i) => (i === index ? { ...r, Discount: v } : r))
                                )
                              }
                              disabled={disabled}
                            />
                          </td>
                          <td className="border border-gray-300 px-2 py-2 text-right text-gray-700 font-medium">
                            {total.toLocaleString("th-TH", { minimumFractionDigits: 2 })}
                          </td>
                          <td className="border border-gray-300 px-2 py-2 text-center">
                            <div className="flex flex-col items-center gap-1">
                              {subImgSrc ? (
                                <>
                                  <img
                                    src={subImgSrc}
                                    alt=""
                                    className="w-[50px] h-[50px] object-cover rounded-md mx-auto"
                                  />
                                  {!disabled && (
                                    <button
                                      type="button"
                                      onClick={() =>
                                        setSubLocations((prev) =>
                                          prev.map((r, i) =>
                                            i === index ? { ...r, Sub_Img: null, Sub_Img_Url: null } : r
                                          )
                                        )
                                      }
                                      className="text-xs text-red-600 hover:underline"
                                    >
                                      ลบรูป
                                    </button>
                                  )}
                                </>
                              ) : (
                                !disabled && (
                                  <label className="cursor-pointer flex flex-col items-center">
                                    <Icon icon="mdi:image-plus" className="w-8 h-8 text-gray-400 hover:text-[#E13F57]" />
                                    <span className="text-xs text-gray-500">แนบรูป</span>
                                    <input
                                      type="file"
                                      accept="image/*"
                                      className="hidden"
                                      onChange={(e) => {
                                        const file = e.target.files?.[0];
                                        if (!file) return;
                                        const reader = new FileReader();
                                        reader.onload = () => {
                                          setSubLocations((prev) =>
                                            prev.map((r, i) =>
                                              i === index
                                                ? { ...r, Sub_Img: reader.result, Sub_Img_Url: reader.result }
                                                : r
                                            )
                                          );
                                        };
                                        reader.readAsDataURL(file);
                                        e.target.value = "";
                                      }}
                                    />
                                  </label>
                                )
                              )}
                            </div>
                          </td>
                          <td className="border border-gray-300 px-2 py-2 text-center">
                            {!disabled && (
                              <button
                                type="button"
                                onClick={() => setSubLocations((prev) => prev.filter((_, i) => i !== index))}
                                className="p-1 text-red-600 hover:bg-red-50 rounded inline-flex items-center justify-center"
                                title="ลบแถว"
                              >
                                <Icon icon="mdi:delete-outline" className="w-5 h-5" />
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}

            {/* ===== VAT Summary สำหรับจุดย่อย ===== */}
            {subLocations.length > 0 && (() => {
              const subNetTotal = subLocations.reduce((sum, r) => sum + (r.Qty * r.Price_Unit - r.Discount), 0);
              const isVat = header?.IsVat === 1;
              const isVatIn = header?.IsVatIn === 1;
              const vatAmount = isVat
                ? subNetTotal * 0.07
                : isVatIn
                ? subNetTotal - subNetTotal / 1.07
                : 0;
              const grandTotal = isVat ? subNetTotal + vatAmount : subNetTotal;
              return (
                <div className="flex justify-end mt-3">
                  <div className="w-72 space-y-2 text-[14px]">
                    <div className="flex justify-between items-center py-1">
                      <span className="text-gray-600">ราคารวม</span>
                      <span className="font-medium">{subNetTotal.toLocaleString("th-TH", { minimumFractionDigits: 2 })}</span>
                    </div>

                    <div className="flex gap-6 items-center py-1 border-t border-gray-200">
                      <label className={`flex items-center gap-1.5 ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}>
                        <input
                          type="checkbox"
                          checked={isVat}
                          disabled={disabled}
                          onChange={() => {
                            if (disabled) return;
                            setHeader((prev) => ({ ...prev, IsVat: prev.IsVat === 1 ? 0 : 1, IsVatIn: 0 }));
                          }}
                          className="h-4 w-4 accent-[#E13F57]"
                        />
                        <span className="text-gray-700">VAT <span className="text-gray-400 text-xs">(+7%)</span></span>
                      </label>
                      <label className={`flex items-center gap-1.5 ${disabled ? "cursor-not-allowed opacity-60" : "cursor-pointer"}`}>
                        <input
                          type="checkbox"
                          checked={isVatIn}
                          disabled={disabled}
                          onChange={() => {
                            if (disabled) return;
                            setHeader((prev) => ({ ...prev, IsVatIn: prev.IsVatIn === 1 ? 0 : 1, IsVat: 0 }));
                          }}
                          className="h-4 w-4 accent-[#E13F57]"
                        />
                        <span className="text-gray-700">VAT in</span>
                      </label>
                    </div>

                    {(isVat || isVatIn) && (
                      <div className="flex justify-between items-center text-gray-500 py-1">
                        <span>ภาษีมูลค่าเพิ่ม (7%)</span>
                        <span>{vatAmount.toLocaleString("th-TH", { minimumFractionDigits: 2 })}</span>
                      </div>
                    )}

                    <div className="flex justify-between items-center font-bold text-[15px] border-t-2 border-gray-300 pt-2">
                      <span>รวมทั้งสิ้น</span>
                      <span className="text-[#E13F57]">{grandTotal.toLocaleString("th-TH", { minimumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>
        )}
      </div>

      {customerModalOpen && (
        <CustomerModal
          isOpen={customerModalOpen}
          onClose={() => setCustomerModalOpen(false)}
          onSelect={(customer) => {
            const fullName = `${customer.AR_Name || ""} ${
              customer.AR_LastName || ""
            }`.trim();
            setHeader((prev) => ({
              ...prev,
              AR_Id: customer.AR_Id,
              AR_Name: fullName,
              ServiceAddr_Id: null,
              ServiceAddr_Name: "",
              ServiceAddr_FullText: "",
              DisplayName: prev.DisplayName?.trim() ? prev.DisplayName : fullName,
              Service_ContactName: "",
              Service_ContactTel: "",
              Contract_ServiceAddr_Id: null,
              Contract_ServiceAddr_Name: "",
              Contract_ServiceAddr_FullText: "",
              Contract_ContactName: "",
              Contract_ContactTel: "",
            }));
            setCustomerModalOpen(false);
          }}
        />
      )}

      {serviceModalOpen && (
        <ServiceLocationModal
          isOpen={serviceModalOpen}
          onClose={() => setServiceModalOpen(false)}
          arId={header.AR_Id}
          purpose={serviceModalPurpose || "2"}
          locations={serviceLocations.filter((l) =>
            serviceModalPurpose === "3"
              ? (l.ServicePurpose_Name || "").trim() === "ที่อยู่ทำสัญญา" || Number(l.ServicePurpose) === 7
              : (l.ServicePurpose_Name || "").trim() === "ที่อยู่บริการ" || Number(l.ServicePurpose) === 6
          )}
          onSelect={async (loc, needsReload = false) => {
            if (serviceModalPurpose === "3") {
              setHeader((prev) => ({
                ...prev,
                Contract_ServiceAddr_Id: loc.ServiceAddr_Id,
                Contract_ServiceAddr_Name: loc.ServiceAddr_Name,
                Contract_ServiceAddr_FullText:
                  loc.ServiceAddr_FullName || formatAddress(loc),
                Contract_ContactName: loc.AR_ContactName || "",
                Contract_ContactTel: formatPhone(loc.AR_Tel || ""),
              }));
            } else {
              setHeader((prev) => ({
                ...prev,
                ServiceAddr_Id: loc.ServiceAddr_Id,
                ServiceAddr_Name: loc.ServiceAddr_Name,
                ServiceAddr_FullText:
                  loc.ServiceAddr_FullName || formatAddress(loc),
                Service_ContactName: loc.AR_ContactName || "",
                Service_ContactTel: formatPhone(loc.AR_Tel || ""),
              }));
            }

            setServiceModalOpen(false);

            if (needsReload && header.AR_Id) {
              try {
                const res = await api.get(`/get-tb-set-ar1/${header.AR_Id}`);
                if (res.data.status === "OK") {
                  const c = res.data.result.recordset[0];
                  const fullName = `${c.AR_Name} ${c.AR_LastName || ""}`.trim();
                  setHeader((prev) => ({
                    ...prev,
                    AR_Name: fullName,
                    DisplayName: prev.DisplayName || fullName,
                  }));
                }
              } catch (err) {
                console.error("Reload customer failed:", err);
              }
            }
          }}
        />
      )}

      {locationModalOpen && (
        <LocationModal
          isOpen={locationModalOpen}
          onClose={() => setLocationModalOpen(false)}
          ServiceAddr_Id={header.ServiceAddr_Id}
          serviceTypes={serviceTypes}
          onSave={async (formData) => {
            try {
              let res;
              if (formData.ServiceAddr_Id) {
                res = await api.put(
                  `/update-tb-set-service-addr/${formData.ServiceAddr_Id}`,
                  formData
                );
              } else {
                res = await api.post(`/create-tb-set-service-addr`, formData);
              }

              if (res.data.status === "OK") {
                const refresh = await api.get(
                  `/get-tb-set-service-addr/${header.AR_Id}`
                );
                if (
                  refresh.data.status === "OK" &&
                  refresh.data.result?.recordset?.length > 0
                ) {
                  const latest = refresh.data.result.recordset[0];
                  const fullAddr = formatAddress(latest);

                  setHeader((prev) => ({
                    ...prev,
                    ServiceAddr_Id: latest.ServiceAddr_Id,
                    ServiceAddr_Name: latest.ServiceAddr_Name,
                    ServiceAddr_FullText: fullAddr,
                    Service_ContactName:
                      latest.AR_ContactName || prev.Service_ContactName || "",
                    Service_ContactTel: formatPhone(
                      latest.AR_Tel || prev.Service_ContactTel || ""
                    ),
                  }));

                  setServiceLocations(refresh.data.result.recordset || []);
                }

                setLocationModalOpen(false);
              } else {
                Swal.fire({
                  icon: "error",
                  title: "เกิดข้อผิดพลาดในการบันทึกข้อมูล",
                });
              }
            } catch {
              Swal.fire("ผิดพลาด", "เกิดข้อผิดพลาดในการบันทึก", "error");
            }
          }}
        />
      )}
      {showFileModal && (
        <FileModalLocation
          mode="E"
          showViewAttachModal={showFileModal}
          setShowViewAttachModal={setShowFileModal}
          selectedFiles={selectedFiles}
          setSelectedFiles={setSelectedFiles}
          ServiceAddr_Id={null}
          Doc_Id={Doc_Id}
          docCodeId={6}
        />
      )}
    </div>
  );
}
